/* Central source of truth for storefront search aliases. */
(() => {
  const groups = {
    'FC Barcelona': [
      'Barcelona',
      'Barça',
      'Barca',
      'Barsa',
      'FCB',
      'Futbol Club Barcelona',
      'Fútbol Club Barcelona',
      'Blaugrana',
      'Culés',
    ],
    España: ['Espana', 'Selección Española', 'Seleccion Española', 'Seleccion Espanola', 'La Roja'],
    'Atlético de Madrid': ['Atleti', 'Atletico Madrid', 'Atlético Madrid', 'Colchoneros', 'Rojiblancos', 'Rojiblanca'],
    'Athletic Club': ['Athletic Bilbao', 'Bilbao', 'Leones'],
    'CA Osasuna': ['Osasuna', 'Rojillos'],
    'RC Celta': ['Celta', 'Celta Vigo', 'Celestes'],
    'Deportivo Alavés': ['Alaves', 'Alavés', 'Babazorros'],
    'Elche CF': ['Elche'],
    'Levante UD': ['Levante'],
    'Málaga CF': ['Malaga', 'Málaga'],
    'RC Deportivo': ['Deportivo La Coruna', 'Deportivo La Coruña'],
    'RCD Espanyol': ['Espanyol', 'Español', 'Pericos'],
    'RCD Mallorca': ['Mallorca', 'Bermellones'],
    'Real Betis': ['Betis', 'Béticos', 'Verdiblancos'],
    'Real Madrid': ['RM', 'Real Madrid CF', 'Merengues', 'Los Blancos'],
    'Real Racing Club': ['Racing de Santander', 'Racing Santander'],
    'Real Sociedad': ['La Real', 'Txuri Urdin'],
    'Sevilla FC': ['Sevilla', 'Nervionenses'],
    'Valencia CF': ['Valencia', 'Ché'],
    'CD Leganés': ['Leganes', 'Leganés'],
    'CD Tenerife': ['Tenerife'],
    'Cádiz CF': ['Cadiz', 'Cádiz'],
    'Córdoba CF': ['Cordoba', 'Córdoba'],
    'Real Oviedo': ['Oviedo'],
    'Real Valladolid': ['Valladolid'],
    'Girona FC': ['Girona'],
    'Getafe CF': ['Getafe'],
    'Rayo Vallecano': ['Rayo', 'Franjirrojos'],
    'UD Almería': ['Almeria', 'Almería'],
    'UD Las Palmas': ['Las Palmas', 'UDLP', 'Pío Pío'],
    'SD Eibar': ['Eibar'],
    'Albacete Balompié': ['Albacete'],
    'AC Milan': ['Milan', 'Milán AC', 'Rossoneri'],
    'AS Monaco': ['Monaco'],
    'AS Roma': ['Roma', 'Giallorossi'],
    'Arsenal FC': ['Arsenal', 'Gunners'],
    'Bayer 04 Leverkusen': ['Bayer Leverkusen', 'Leverkusen'],
    'Boca Juniors': ['Boca', 'Xeneizes'],
    'Borussia Dortmund': ['Dortmund', 'BVB'],
    'Chelsea FC': ['Chelsea', 'The Blues'],
    'Eintracht Frankfurt': ['Eintracht', 'Frankfurt'],
    'FC Bayern de Múnich': ['Bayern', 'Bayern Munich', 'Bayern München', 'Bávaros'],
    'Inter de Milán': ['Inter Milan', 'Internazionale', 'Inter de Milan', 'Nerazzurri'],
    'Juventus FC': ['Juventus', 'Juve', 'Bianconeri', 'Vecchia Signora'],
    'LOSC Lille': ['Lille', 'Lille OSC'],
    'Liverpool FC': ['Liverpool', 'The Reds'],
    'Manchester City': ['Man City', 'Citizens'],
    'Manchester United': ['Man United', 'Man Utd', 'Man U', 'Red Devils'],
    'Olympique de Lyon': ['Lyon', 'Olympique Lyonnais', 'OL'],
    'Olympique de Marseille': ['Marseille', 'OM'],
    'Paris Saint-Germain': ['PSG', 'Paris SG', 'Paris Saint Germain', 'Parisinos'],
    'RB Leipzig': ['Leipzig'],
    'Racing Club': ['Racing de Avellaneda', 'La Academia'],
    'River Plate': ['River', 'Millonarios'],
    'San Lorenzo': ['San Lorenzo de Almagro', 'El Ciclón'],
    'SSC Napoli': ['Napoli', 'Partenopei'],
    'Independiente': ['CA Independiente', 'Independiente de Avellaneda', 'El Rojo'],
    Alemania: ['Germany', 'Selección Alemana', 'Die Mannschaft'],
    Argentina: ['Argentina', 'Selección Argentina', 'Albiceleste'],
    Brasil: ['Brazil', 'Selección Brasileña', 'Selecao', 'Canarinha', 'Verdeamarela'],
    Colombia: ['Selección Colombiana', 'Cafeteros'],
    Croacia: ['Croatia', 'Selección Croata', 'Vatreni'],
    'Estados Unidos': ['USA', 'United States', 'USMNT'],
    Francia: ['France', 'Selección Francesa', 'Les Bleus'],
    Inglaterra: ['England', 'Selección Inglesa', 'Three Lions'],
    Italia: ['Italy', 'Selección Italiana', 'Azzurri'],
    Japón: ['Japon', 'Japan', 'Selección Japonesa', 'Samurai Blue'],
    México: ['Mexico', 'Selección Mexicana', 'El Tri'],
    'Países Bajos': ['Paises Bajos', 'Netherlands', 'Holanda', 'Oranje'],
    Portugal: ['Selección Portuguesa', 'Seleção das Quinas'],
    Uruguay: ['Selección Uruguaya', 'La Celeste', 'Charrúas'],
  };

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('es')
      .replace(/\s+/g, ' ')
      .trim();

  const aliases = Object.entries(groups)
    .flatMap(([canonical, values]) => values.map((alias) => ({ canonical, alias: normalize(alias) })))
    .sort((a, b) => b.alias.length - a.alias.length);

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const expand = (query) => {
    const source = normalize(query);
    if (!source) return String(query || '');

    let result = source;
    let changed = false;
    const canonicalTokens = new Map();
    Object.keys(groups)
      .sort((a, b) => normalize(b).length - normalize(a).length)
      .forEach((canonical, index) => {
        const token = `\u0000${index}\u0000`;
        const pattern = new RegExp(`(^|\\s)${escapeRegExp(normalize(canonical)).replace(/\\ /g, '\\s+')}(?=\\s|$)`, 'g');
        const protectedResult = result.replace(pattern, (_match, prefix) => `${prefix}${token}`);
        if (protectedResult !== result) changed = true;
        result = protectedResult;
        canonicalTokens.set(token, canonical);
      });

    aliases.forEach(({ canonical, alias }) => {
      const pattern = new RegExp(`(^|\\s)${escapeRegExp(alias).replace(/\\ /g, '\\s+')}(?=\\s|$)`, 'g');
      const token = [...canonicalTokens].find(([, value]) => value === canonical)?.[0] || canonical;
      const next = result.replace(pattern, (_match, prefix) => `${prefix}${token}`);
      changed = changed || next !== result;
      result = next;
    });

    canonicalTokens.forEach((canonical, token) => {
      result = result.replaceAll(token, canonical);
    });

    return changed ? result : String(query || '').trim().replace(/\s+/g, ' ');
  };

  window.StoreSearchAliases = Object.freeze({ groups, normalize, expand });
})();
